import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ApolloClient, InMemoryCache } from '@apollo/client';
import getLink from './get-link';
const isBrowser = typeof window !== 'undefined';
const linkOptions = {
  fetch: !isBrowser ? fetch : undefined
};
function createApolloClient(options) {
  const {
    resolvers,
    initialState = {},
    possibleTypes,
    typePolicyQueryFields = {},
    addTypename = true
  } = options;
  const cache = new InMemoryCache({
    addTypename,
    possibleTypes,
    typePolicies: {
      Query: {
        fields: _objectSpread(_objectSpread({}, typePolicyQueryFields), {}, {
          getEntitySchema: {
            read(_, {
              args,
              toReference
            }) {
              return toReference({
                __typename: 'DataEntitySchemaDefinition',
                id: args.id
              });
            }
          }
        })
      }
    }
  }).restore(initialState);
  const link = getLink(_objectSpread(_objectSpread({}, options), {}, {
    linkOptions
  }));
  return new ApolloClient({
    connectToDevTools: isBrowser && process.env.NODE_ENV !== 'production',
    ssrMode: !isBrowser,
    // Disables forceFetch on the server (so queries are only run once)
    resolvers,
    cache,
    link
  });
}
export default createApolloClient;
//# sourceMappingURL=create-client.js.map